const titulos={
    VentanaCrear:"Detalles de Usuario",
}

const notificaciones={
    creacion:"Usuario Creado",
    modificacion:"Usuario Modificado",
    eliminacion: "Usuario Desactivado",
    error:"Algo salio mal"
}

export {titulos,notificaciones}